export { Link } from 'gatsby'
